import styled from "styled-components";
import {Select} from "antd";
import {CustomButton} from "components/_defaultComponents/CustomButton/CustomButton";

export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
`;

export const TabRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    gap: 15px;
    flex-wrap: wrap;
    margin-left: 0;

    &.navigation-buttons-row {
        margin-right: 20px;
        margin-bottom: 20px;
        flex-wrap: nowrap;
        @media screen and (max-width: 768px) {
            flex-wrap: wrap;
        }
    }

    &.past-shifts-tab-row {
        width: 100%;
        margin-bottom: 15px;
        position: relative;
        margin-left: 0;
        z-index: 10;
    }

    @media (max-width: 1235px) {
        flex-wrap: wrap;
        &.past-shifts-tab-row {
            margin-top: 20px;
            margin-bottom: 15px;
        }
    }

    @media (max-width: 992px) {
        gap: 12px;

        &.past-shifts-tab-row {
            margin-top: 15px;
            margin-bottom: 12px;
        }
    }

    @media (max-width: 992px) {
        gap: 12px;

        &.past-shifts-tab-row {
            margin-top: 15px;
            margin-bottom: 12px;
        }
    }

    @media (max-width: 768px) {
        gap: 10px;

        &.past-shifts-tab-row {
            margin-top: 12px;
            margin-bottom: 10px;
        }
    }

    @media (max-width: 480px) {
        gap: 8px;

        &.past-shifts-tab-row {
            margin-top: 10px;
            margin-bottom: 8px;
        }
    }
`;

export const CustomTab = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    width: 110px;
    height: 120px;
    border-radius: 5px;
    text-align: center;
    padding: 4px;
    padding-top: 12px;
    padding-bottom: 12px;
    font-size: 13px;
    font-weight: ${$props => ($props.isActive ? "bold" : "normal")};
    &.navigation-button {
        width: 150px;
        height: 170px;
    }

    /* Customer panel theme */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    border: ${$props => ($props.isActive ? "1px solid #91d5ff" : "none")};
    background-color: ${$props => ($props.isActive ? "#e6f7ff" : "white")};

    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    z-index: 11;

    b {
        line-height: 1.2;
    }

    img {
        width: 100%;
        max-height: 50px;
    }

    .anticon {
        font-size: 18px;
        color: ${props => props.iconColor || "#333"};
        background-color: ${props => props.iconBgColor || "#aef001"};
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: ${props => (props.iconBgColor === "#fa8c16" ? "none" : "center")};
        justify-content: center;
        margin-bottom: 8px;
        padding-top: ${props => (props.iconBgColor === "#fa8c16" ? "4px" : "0")};
    }

    /* SVG ikonları için de aynı stil */
    img {
        width: 28px;
        height: 28px;
        color: #333;
        background-color: #aef001;
        border-radius: 50%;
        padding: 11px;
        margin-bottom: 8px;
    }

    /* Tab içindeki sayı ve etiket düzeni */
    > div:last-child {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;

        > div:first-child {
            font-size: 24px;
            font-weight: 700;
            line-height: 1;
        }

        > div:last-child {
            font-size: 14px;
            font-weight: 600;
            line-height: 1.2;
            text-align: center;
        }
    }

    &:hover {
        background-color: ${$props => ($props.isActive ? "#e6f7ff" : "#f7f7f7")};
    }

    @media (min-width: 992px) and (max-width: 1440px) {
        width: 150px;
        height: 140px;
        padding: 3px;
        padding-top: 14px;
        padding-bottom: 14px;
        font-size: 15px;

        .anticon {
            font-size: 24px;
            width: 45px;
            height: 45px;
        }

        img {
            width: 24px;
            height: 24px;
            padding: 10px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 32px;
            }
            > div:last-child {
                font-size: 11px;
            }
        }
    }

    @media (min-width: 768px) and (max-width: 992px) {
        width: 130px;
        height: 120px;
        padding: 3px;
        padding-top: 12px;
        padding-bottom: 12px;
        font-size: 14px;
        gap: 6px;

        .anticon {
            font-size: 24px;
            width: 45px;
            height: 45px;
        }

        img {
            width: 24px;
            height: 24px;
            padding: 10px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 28px;
            }
            > div:last-child {
                font-size: 10px;
            }
        }
    }

    @media (min-width: 480px) and (max-width: 768px) {
        width: 110px;
        height: 100px;
        padding: 2px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 13px;
        gap: 4px;

        .anticon {
            font-size: 20px;
            width: 40px;
            height: 40px;
        }

        img {
            width: 20px;
            height: 20px;
            padding: 10px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 24px;
            }
            > div:last-child {
                font-size: 9px;
            }
        }
    }

    @media (max-width: 480px) {
        width: 90px;
        height: 85px;
        padding: 2px;
        padding-top: 8px;
        padding-bottom: 8px;
        font-size: 12px;
        gap: 3px;

        .anticon {
            font-size: 18px;
            width: 35px;
            height: 35px;
        }

        img {
            width: 18px;
            height: 18px;
            padding: 8px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 20px;
            }
            > div:last-child {
                font-size: 8px;
            }
        }
    }

    @media (max-width: 360px) {
        width: 80px;
        height: 75px;
        padding: 1px;
        padding-top: 6px;
        padding-bottom: 6px;
        font-size: 11px;
        gap: 2px;

        .anticon {
            font-size: 16px;
            width: 30px;
            height: 30px;
        }

        img {
            width: 16px;
            height: 16px;
            padding: 6px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 18px;
            }
            > div:last-child {
                font-size: 7px;
            }
        }
    }
`;

export const ActionButtonsRow = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 8px;
    }
`;

export const ExportButton = styled(CustomButton)`
    margin-left: auto;
`;

export const FilterTabsContainer = styled.div`
    display: flex;
    gap: 8px;
    height: 32px;
    align-items: center;
    width: 100%;
    flex-wrap: nowrap;

    @media (max-width: 1235px) {
        flex-wrap: wrap;
    }

    @media (max-width: 768px) {
        justify-content: flex-start;
        gap: 6px;
        height: auto;
        min-height: 32px;
        flex-wrap: wrap;
    }

    @media (max-width: 480px) {
        gap: 4px;
        height: auto;
        min-height: 32px;
        flex-wrap: wrap;
    }
`;

export const FilterTab = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-direction: row;
    height: 32px;
    padding: 4px 12px;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: ${props => (props.isActive ? "bold" : "normal")};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    border: ${props => (props.isActive ? "1px solid #91d5ff" : "none")};
    background-color: ${props => (props.isActive ? "#e6f7ff" : "white")};
    white-space: nowrap;

    &:hover {
        background-color: ${props => (props.isActive ? "#e6f7ff" : "#f7f7f7")};
    }

    .anticon {
        font-size: 14px;
        color: ${props => props.iconColor || "#333"};
        background-color: ${props => props.iconBgColor || "#aef001"};
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    span {
        font-size: 12px;
        white-space: nowrap;
    }

    @media (max-width: 768px) {
        padding: 4px 10px;
        height: 30px;

        .anticon {
            font-size: 12px;
            width: 18px;
            height: 18px;
        }

        span {
            font-size: 11px;
        }
    }

    @media (max-width: 480px) {
        padding: 3px 8px;
        height: 28px;
        gap: 3px;

        .anticon {
            font-size: 11px;
            width: 16px;
            height: 16px;
        }

        span {
            font-size: 10px;
        }
    }
`;

export const FilterTabContent = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-direction: row;
    max-width: 120px;
`;

export const FilterTabContentDate = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-direction: row;
    width: 90px;
`;

export const FilterTabsContainerDates = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    @media (max-width: 480px) {
        flex-direction: column;
    }
`;

export const PastShiftsFilters = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: ${props => (props.hasMultipleSubcompanies ? "0" : "15px")};
    width: 100%;

    @media (max-width: 1235px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-bottom: 10px;
    }

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 10px;
    }
`;

export const FutureShiftsFilters = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: ${props => (props.hasMultipleSubcompanies ? "0" : "15px")};
    width: 100%;

    @media (max-width: 1235px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-bottom: 10px;
    }

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 10px;
    }
`;

export const LeftFiltersContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 3;
    margin-right: 30px;

    @media (max-width: 1235px) {
        flex: none;
        width: 100%;
        margin-right: 0;
        flex-wrap: wrap;
        margin-bottom: 10px;
    }

    @media (max-width: 768px) {
        gap: 8px;
    }
`;

export const RightFiltersContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;

    @media (max-width: 1235px) {
        flex: none;
        width: 100%;
        justify-content: flex-start;
    }

    @media (max-width: 768px) {
        gap: 8px;
    }
`;

export const SubcompanyFilterContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    min-width: 200px;
    width: 320px;
`;

export const CustomerHomePageButtonContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;

    @media (max-width: 1235px) {
        flex-direction: column;
        align-items: stretch;
        gap: 15px;
    }

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 480px) {
        gap: 10px;
    }
`;

export const CustomerNavigationContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex: 3;

    @media (max-width: 1235px) {
        flex: none;
        width: 100%;
    }

    @media (max-width: 768px) {
        gap: 8px;
        flex-direction: column;
    }
`;

export const CustomerHomePageMapContainer = styled.div`
    flex: 2;
    height: 170px;
    border: 2px solid #aef001;
    border-radius: 6px;
    position: relative;
    z-index: 1;

    @media (max-width: 1235px) {
        flex: none;
        width: 100%;
        height: 200px;
    }

    @media (max-width: 768px) {
        height: 180px;
    }

    @media (max-width: 480px) {
        height: 160px;
    }
`;
